import {
  grantOrganizationCredits as requestGrantOrganizationCredits,
  updateCurrentOrganization as requestUpdateCurrentOrganization
} from "@utils/aegean_api_handler";

import { notify } from "@utils/notifications";

export const UPDATE_CURRENT_ORGANIZATION_REQUEST = "UPDATE_CURRENT_ORGANIZATION_REQUEST";
export const UPDATE_CURRENT_ORGANIZATION_SUCCESS = "UPDATE_CURRENT_ORGANIZATION_SUCCESS";
export const UPDATE_CURRENT_ORGANIZATION_ERROR = "UPDATE_USER_ROLE_ERROR";
export const GRANT_ORGANIZATION_CREDITS_REQUEST = "GRANT_ORGANIZATION_CREDITS_REQUEST";
export const GRANT_ORGANIZATION_CREDITS_SUCCESS = "GRANT_ORGANIZATION_CREDITS_SUCCESS";
export const GRANT_ORGANIZATION_CREDITS_ERROR = "GRANT_ORGANIZATION_CREDITS_ERROR";

export const updateCurrentOrganization = data => (dispatch) => {
  dispatch({ type: UPDATE_CURRENT_ORGANIZATION_REQUEST });

  return requestUpdateCurrentOrganization(data)
    .then(({ response: { message, organization } }) => {
      notify(message);
      dispatch({
        type: UPDATE_CURRENT_ORGANIZATION_SUCCESS,
        organization
      });
    })
    .catch((error) => {
      dispatch({
        type: UPDATE_CURRENT_ORGANIZATION_ERROR,
        error
      });
    });
};

export const grantOrganizationCredits = amount => (dispatch) => {
  dispatch({ type: GRANT_ORGANIZATION_CREDITS_REQUEST });

  return requestGrantOrganizationCredits(amount)
    .then(({ response: { message, organization } }) => {
      notify(message);
      dispatch({
        type: GRANT_ORGANIZATION_CREDITS_SUCCESS,
        organization
      });
    })
    .catch((error) => {
      dispatch({
        type: GRANT_ORGANIZATION_CREDITS_ERROR,
        error
      });
    });
};
